export default __webpack_public_path__ + "static/media/orangeAlert.ce08c385.svg";